import { render, staticRenderFns } from "./CreateIncidentModal.vue?vue&type=template&id=c9c9c17c&"
import script from "./CreateIncidentModal.vue?vue&type=script&lang=js&"
export * from "./CreateIncidentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports